<template>
  <div class="Big-box">
    <WalletHead />
    <div class="Big-box2">
      <div class="felx">
        <img src="../../public/about/os.png" alt class="pic-kefu" />
      </div>
      <span class="contact-span" >Contact Now !</span>
      <!-- <div class="box">
        <div>
          <button
            class="bt1"
            style="font-size:20px"
            @click="ha()"
          >Contact Customer Service 1<img src="../../public/about/air.png" style="padding-left: 15px;" alt class="picair" /></button>
        </div>
        <div class="picair-box">

        </div>
      </div>&nbsp;
      &nbsp; -->
      <div class="box">
        <div>
          <button
            @click="hb()"
            class="bt1"
            style="font-size:20px"
          >Contact Customer Service<img src="../../public/about/air.png" style="padding-left: 15px;" alt class="picair" /></button>
        </div>
        <div class="picair-box">

        </div>
      </div>

      <div class="flex">
        <p style="font-size:20px;color:white;line-height: 40px">Operating Hours 10:00 AM to 10:00 PM</p>
      </div>

      <el-collapse  v-model="activeName"  >
        <el-collapse-item
            class="bgc"
            style="width: 90%"
          title="1. What are the loan terms?"
          name="1"
        >
          <div>Step one, you have to fill all your personal information required in the application and you need to have an ID card and a bank account to apply for the loan.</div>
        </el-collapse-item>
        <div style="width:20px;height:10px;"></div>
        <el-collapse-item
            class="bgc"
            style="width: 90%"
          title="2. How long does it take to apply for a loan?"
          name="2"
        >
          <div>From the time of registration, verification of personal information will be considered at the earliest and will continue till the final stage of delivery within 1 hour, please contact customer service staff for more specific information.</div>
        </el-collapse-item>
        <div style="width:20px;height:10px;"></div>
        <el-collapse-item
            class="bgc"
            style="width: 90%"
          title="3. How to check loan?"
          name="3"
        >
          <div>You can visit (website) - (List of Loan Criteria) It usually takes 1-24 hours to get approved</div>
        </el-collapse-item>
        <div style="width:20px;height:10px;"></div>
        <el-collapse-item
            class="bgc"
            style="width: 90%"
          title="4. How to get refund after credit line is approved?"
          name="4"
        >
          <div>
            After the loan is successful , payments will be automatically debited from your bank account on the 15th of each month. Please ensure sufficient funds are available in your account on this date. Failure to maintain a suitable balance may result in negative remarks on your credit profile, probably leading to future financial difficulties.
          </div>
        </el-collapse-item>
        <div style="width:20px;height:10px;"></div>
        <el-collapse-item
            class="bgc"
            style="width: 90%"
          title="5. How can I contact the Customer Service Department?"
          name="5"
        >
          <div>You can click on "Contact Customer Service 1 or 2" to connect with our online Customer Service Department. We are available from 10:00 AM to 10:00PM.</div>
        </el-collapse-item>
        <div style="width:20px;height:10px;"></div>
        <el-collapse-item
            class="bgc"
            style="width: 90%"
          title="6. Can I sign out of my account?"
          name="6"
        >
          <div>Monthly service that partially "cancels your account" information you enter for personal protection is limited to loan applications.</div>
        </el-collapse-item>
        <div style="width:20px;height:10px;"></div>
      </el-collapse>
    </div>
    <MenuTop />
  </div>
</template>

<script>
import MenuTop from "@/components/MenuTop.vue";
import WalletHead from "../components/WalletHead.vue";
import axios from "axios";
export default {
  components: {
    MenuTop,
    WalletHead
  },
  data() {
    return {
      activeName: "0"
    };
  },
  methods: {
    // ha() {
    //   window.location.href = "https://t.me/Customerservices_01";
    // },
    hb() {
      window.location.href = "https://t.me/customercare02";
    }
  }
};
</script>

<style scoped>
::v-deep .el-collapse-item__header {
  font-size: 20px;
  height: auto;
  line-height: auto;
  text-align: left;
  border-radius: 30px;
  background-color: #a95159;
  color: white;
  padding-left: 15px;
}
::v-deep .l-collapse-item {
  border-radius: 5px;
}
::v-deep .el-collapse-item__content {
  font-size: 20px;
  line-height: auto;
}
.pic-kefu {
  margin-top: 10px;
  width: 100%;
  height: 229.75px;
}
.Big-box {
  width: 100%;
  height: 800px;
}
.Big-box2 {
  width: 100%;
  height: auto;
  margin-top: 60px;
  padding-bottom: 50px;
}
.picair-box {
  margin-left: -40px;
  margin-top: 10px;
}
.picair {
  margin-top: -3px;
  position: absolute;
  width: 30px;
  height: 30px;
}
.felx {
  display: flex;
  justify-content: center;
}
.box {
  //display: flex;
  justify-content: center;
}
.big-box1 {
  margin-top: 50px;
  width: 100%;
  height: 100%;
  /* display:flex; */
  justify-content: center;
  /* flex-direction: column; */
}
.bt1 {
  position: relative;
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #a95159;
  color: aliceblue;
  font-size: 100%;
}
.bt1-wight {
  width: 100%;
  height: 10px;
}
.p1 {
  font-size: 18px;
  color: rgb(123, 90, 19);
}
.airpic {
  width: 30px;
  height: 30px;
  margin-top: -10;
}
.contact-span{
  font-size: 30px;
  color: #a95159;
  line-height: 50px;
}
.flex{
  margin: 0 auto;
  width: 90%;
  height: 40px;
  border-radius: 10px;
  margin-bottom: 20px;
  background-color: #a95159;
}
.bgc{
  margin-left: 20px;
}
</style>
